<template>
  <div
    class="py-4 container-fluid min-vh-100"
    :class="$store.state.isDarkMode ? 'glossary-page-dark' : 'bg-light-moniex text-dark'"
    :style="$store.state.isDarkMode
      ? 'background: #1E293B !important; min-height: 100vh;'
      : 'background: #f8f9fa; min-height: 100vh;'"
  >
    <div
      class="glossary-hero-banner mb-3"
      :style="$store.state.isDarkMode
        ? 'background: #0F172A !important; border: 1px solid #334155 !important; box-shadow: none !important; color: #E2E8F0 !important; border-radius: 0.65rem !important;'
        : 'border-radius: 0.65rem !important;'"
    >
      <div class="glossary-hero-content">
        <h1
          class="glossary-hero-title"
          :style="$store.state.isDarkMode
            ? 'color: #FF8A4C !important; font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'
            : 'font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'"
        >Slovník investora</h1>
        <p :style="$store.state.isDarkMode ? 'color: #CBD5E1 !important; opacity: 1;' : ''">Rychlý přehled nejdůležitějších pojmů z burzy, které ti pomohou ovládnout trh.</p>
      </div>
    </div>

    <div v-if="GlossaryData && GlossaryData.length" class="row">
      
      <div class="col-12 col-lg-8">
        <div
          class="border-0 shadow-sm rounded-4 mb-3 overflow-hidden moniex-inbox-card p-4"
          :style="surfaceStyle"
        >
          <div class="position-relative glossary-search">
            <fa-icon
              icon="fa-solid fa-magnifying-glass"
              class="position-absolute glossary-search-icon"
              :class="$store.state.isDarkMode ? 'text-slate-400' : 'text-muted'"
            />
            <input
              v-model="searchQuery"
              type="text"
              class="form-control py-2 rounded-pill"
              :class="$store.state.isDarkMode ? 'glossary-search-input-dark' : 'glossary-search-input-light'"
              placeholder="Hledat pojem..."
            />
            <button
              v-if="searchQuery"
              type="button"
              class="btn p-0 border-0 position-absolute glossary-search-clear"
              :class="$store.state.isDarkMode ? 'text-slate-400' : 'text-muted'"
              aria-label="Smazat filtr"
              @click="searchQuery = ''"
            >
              <fa-icon icon="fa-solid fa-times" />
            </button>
          </div>
        </div>

        <div
          v-if="searchQuery && !filteredGlossary.length"
          class="border-0 shadow-sm rounded-4 mb-3 overflow-hidden moniex-inbox-card p-4"
          :style="surfaceStyle"
        >
          <p
            class="mb-0"
            :style="$store.state.isDarkMode ? 'color: #94A3B8 !important;' : ''"
            :class="{ 'text-muted': !$store.state.isDarkMode }"
          >Nic se nenašlo.</p>
        </div>

        <div
          v-for="(data) in filteredGlossary"
          :key="data.GlossaryID"
          class="border-0 shadow-sm rounded-4 mb-3 overflow-hidden moniex-inbox-card p-4"
          :style="surfaceStyle"
        >
          <div class="d-flex align-items-start">
            <div 
              class="avatar-circle me-3 fw-bold"
              :class="`bg-${data.GlossaryColor || 'primary'}-soft text-${data.GlossaryColor || 'primary'}`"
            >
              {{ data.GlossaryName ? data.GlossaryName.charAt(0) : 'G' }}
            </div>

            <div class="w-100">
              <div class="d-flex justify-content-between align-items-center mb-1 flex-wrap">
                <h5
                  class="mb-0 fw-bold fs-5"
                  :style="$store.state.isDarkMode ? 'color: #E2E8F0 !important;' : 'color: #212529;'"
                >{{ data.GlossaryName }}</h5>
                <span 
                  class="badge-moniex"
                  :class="`bg-${data.GlossaryColor || 'primary'}-soft text-${data.GlossaryColor || 'primary'}`"
                >
                  Glosář
                </span>
              </div>
              
              <div
                class="line-height-lg fs-6 mt-3 glossary-html"
                :style="$store.state.isDarkMode ? 'color: #CBD5E1 !important;' : ''"
                :class="{ 'text-muted': !$store.state.isDarkMode }"
                v-html="data.GlossaryDefinition"
              ></div>

              <div 
                v-if="data.GlossaryExample"
                class="mt-4 p-3 rounded-3"
                :style="$store.state.isDarkMode
                  ? 'background: #1E293B !important; border-left: 4px solid #334155 !important;'
                  : 'background: #f1f3f5 !important; border-left: 4px solid #ced4da !important;'"
              >
                <div class="d-flex align-items-center mb-2">
                  <span class="fs-6 me-2">💡</span>
                  <strong
                    class="fs-6"
                    :style="$store.state.isDarkMode ? 'color: #E2E8F0 !important;' : 'color: #212529;'"
                  >Jak to funguje v reálném světě:</strong>
                </div>
                <span
                  class="small line-height-md glossary-html"
                  :style="$store.state.isDarkMode ? 'color: #94A3B8 !important;' : ''"
                  :class="{ 'text-secondary': !$store.state.isDarkMode }"
                  v-html="data.GlossaryExample"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4 mt-4 mt-lg-0">
        <div
          class="border-0 shadow-sm rounded-4 bg-white text-center img-inga-card position-relative"
          :class="$store.state.isDarkMode ? 'p-0' : 'p-3'"
          :style="$store.state.isDarkMode
            ? 'background: #0F172A !important; border: none !important; box-shadow: none !important; border-radius: 0.65rem !important;'
            : 'background: #ffffff !important; border: none !important; border-radius: 0.65rem !important;'"
        >
          <div
            class="inga-speech-bubble"
            :class="{ 'inga-speech-bubble-dark': $store.state.isDarkMode }"
          >
            „Nerozumíš nějakému slovu nebo hlášce z burzy? Mrkni do slovníku, ať při investování nepůsobíš jako úplný zelenáč!“
          </div>
          <IngaPortrait :src="imgRoot + 'inga.jpg'" />
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import dataService from "@/services/dataService.js";
import IngaPortrait from "./components/custom/IngaPortrait.vue";

const store = useStore();
const GlossaryData = ref([]);
const searchQuery = ref('');
const imgRoot = computed(() => process.env.VUE_APP_IMG_ROOT);

const stripHtml = (value) => String(value || '').replace(/<[^>]+>/g, ' ');

const filteredGlossary = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  const rows = Array.isArray(GlossaryData.value) ? GlossaryData.value : [];
  if (!q) return rows;
  return rows.filter((item) => {
    const hay = [
      item.GlossaryName,
      stripHtml(item.GlossaryDefinition),
      stripHtml(item.GlossaryExample),
    ].join(' ').toLowerCase();
    return hay.includes(q);
  });
});

const surfaceStyle = computed(() => {
  if (store.state.isDarkMode) {
    return "background: #0F172A !important; background-color: #0F172A !important; background-image: none !important; border: 1px solid #334155 !important; --bs-card-bg: #0F172A; border-radius: 0.65rem !important;";
  }
  return "background: #ffffff; border: 1px solid transparent; border-radius: 0.65rem !important;";
});

const fetchGlossaryData = async () => {
  try {
    const response = await dataService.GetGlossary();
    if (response) {
      GlossaryData.value = response;
    }
  } catch (error) {
    // console.error("Chyba při načítání slovníku do frontendu:", error);
  }
};

fetchGlossaryData();
</script>

<style scoped>
.glossary-hero-banner {
  background: linear-gradient(135deg, #FFE8D6 0%, #FFD6BB 100%);
  border: 1px solid #FEC88F;
  border-radius: 0.65rem;
  padding: 16px 24px;
  color: #0F172A;
  box-shadow: none;
}

.glossary-hero-content h1,
.glossary-hero-title {
  font-family: 'Ubuntu Sans', Ubuntu, sans-serif;
  font-size: 1.5rem;
  font-weight: 800 !important;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin-bottom: 4px;
  color: #C2460F;
}

.glossary-hero-content p {
  margin-bottom: 0;
  opacity: 1;
  font-size: 0.88rem;
  line-height: 1.35;
  color: #56647A;
}

.glossary-page-dark .glossary-hero-banner {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  box-shadow: none !important;
}

.glossary-search-icon {
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.85rem;
  pointer-events: none;
}
.glossary-search-clear {
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  line-height: 1;
}
.glossary-search :deep(.form-control) {
  padding-left: 38px;
  padding-right: 40px;
  font-size: 0.9rem;
}
.glossary-search-input-light {
  background-color: #f1f3f5 !important;
  border: 1px solid transparent !important;
  color: #212529 !important;
  box-shadow: none !important;
}
.glossary-search-input-dark {
  background-color: #334155 !important;
  border: 1px solid #475569 !important;
  color: #E2E8F0 !important;
  box-shadow: none !important;
}
.glossary-search-input-dark::placeholder {
  color: #94A3B8;
}

.bg-light-moniex { background-color: #f8f9fa; }

.bg-success-soft { background-color: rgba(40, 167, 69, 0.1) !important; }
.text-success { color: #28a745 !important; }
.bg-danger-soft { background-color: rgba(220, 53, 69, 0.1) !important; }
.text-danger { color: #dc3545 !important; }
.bg-warning-soft { background-color: rgba(255, 193, 7, 0.1) !important; }
.text-warning { color: #ffc107 !important; }
.bg-primary-soft { background-color: rgba(13, 110, 253, 0.1) !important; }
.text-primary { color: #0d6efd !important; }
.bg-info-soft { background-color: rgba(13, 202, 240, 0.1) !important; }
.text-info { color: #0dcaf0 !important; }
.bg-dark-soft { background-color: rgba(33, 37, 41, 0.1) !important; }

.fw-bold { font-weight: 700 !important; }
.line-height-lg { line-height: 1.6; }
.line-height-md { line-height: 1.4; }

.avatar-circle {
  width: 48px !important;
  height: 48px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 1.1rem !important;
  flex-shrink: 0 !important;
}

.badge-moniex {
  padding: 4px 14px !important;
  border-radius: 20px !important;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

.moniex-inbox-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 0.65rem !important;
  overflow: hidden;
}
.moniex-inbox-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.04) !important;
}

.glossary-html :deep(div),
.glossary-html :deep(p),
.glossary-html :deep(span),
.glossary-html :deep(li) {
  background: transparent !important;
  color: inherit !important;
}

.img-inga-card {
  margin-top: 3.5rem !important;
  border: none !important;
  border-radius: 0.65rem !important;
}
.inga-speech-bubble {
  position: absolute !important;
  top: -65px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  background-color: #ffffff !important;
  border: 2px solid #FF7A00 !important;
  color: #1E293B !important;
  font-weight: 700 !important;
  font-size: 0.82rem !important;
  padding: 10px 14px !important;
  border-radius: 16px !important;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.06) !important;
  z-index: 10 !important;
  width: 92% !important;
  max-width: 280px !important;
}
.inga-speech-bubble-dark {
  background-color: #1E293B !important;
  color: #E2E8F0 !important;
}
@media (min-width: 768px) {
  .inga-speech-bubble {
    top: -60px !important;
    padding: 12px 18px !important;
    font-size: 0.88rem !important;
    max-width: 320px !important;
  }
}
.inga-speech-bubble::after, .inga-speech-bubble::before {
  content: ''; position: absolute; bottom: -10px; left: 50%; transform: translateX(-50%); border-style: solid; display: block; width: 0;
}
.inga-speech-bubble::after { border-width: 10px 10px 0; border-color: #ffffff transparent transparent; z-index: 11; }
.inga-speech-bubble::before { bottom: -13px; border-width: 11px 11px 0; border-color: #FF7A00 transparent transparent; z-index: 9; }
.inga-speech-bubble-dark::after { border-color: #1E293B transparent transparent; }
</style>
